module.exports = __webpack_public_path__ + "img/9788901060019.d8d6cf27.jpg";